import React from 'react';
import Body4 from './Body4';
import Bold from './Bold';

export default function TextDefinition({ phrase, definition }) {
  return (
    <Body4>
      {phrase && (
        <>
          <Bold>{phrase}</Bold>{' '}
        </>
      )}

      {definition}
    </Body4>
  );
}
